import React from 'react';
import { default as Styles } from '../styles';

const Lazy = ({ h, fill, cb = () => {} }) => {
  return (
    <div
      style={{
        backgroundColor: fill,
        position: 'relative',
        height: h,
        ...Styles.col_center('center'),
        ...Styles.fill,
      }}
      onClick={() => cb()}
    >
      <p
        style={{
          cursor: 'pointer',
          ...Styles.bold,
          ...Styles.call_to_action,
          ...Styles.uppercase,
        }}
      >
        load chart
      </p>
    </div>
  );
};

export default Lazy;
